import React from "react";
import { WhatsAppShareConfirmModal } from "./whatsappShareModalShared";

interface OrderShareModalProps {
  order: any;
  onClose: () => void;
  onShareOfficial: () => Promise<void>;
  loading?: boolean;
}

const OrderShareModal: React.FC<OrderShareModalProps> = ({
  order,
  onClose,
  onShareOfficial,
  loading = false,
}) => {
  return (
    <WhatsAppShareConfirmModal
      title="Share Order"
      customerName={order?.customer_name || order?.customer?.name || ""}
      customerPhone={order?.customer_phone || order?.customer?.phone || ""}
      documentNumber={order?.order_no || ""}
      grandTotal={order?.grand_total || order?.total || 0}
      pdfFileName={`Order_${order?.order_no || "detail"}.pdf`}
      onClose={onClose}
      onConfirm={onShareOfficial}
      loading={loading}
    />
  );
};

export default OrderShareModal;
